// Extracted out of Tournament.js's own tab-switch scroll restore (see that
// file's comment on preSwitchScrollRef for the full backstory) so the same
// "keep forcing scrollY back to target for as long as something keeps
// fighting it" loop can also run for the Admin/Public View switch - a fixed-
// duration window isn't enough because it's not fighting one single layout
// change, it's fighting every image/field that loads in asynchronously
// after the switch, each one its own reflow. Tracking consecutive
// already-correct frames instead of a fixed tick count means a fast/cached
// switch still stops almost immediately, while a slow one keeps getting
// corrected for as long as something is actually still fighting it - capped
// so a page that never settles can't pin forever. Returns a cancel function.
//
// A genuine user scroll gesture (wheel, touch, or a scroll-relevant key)
// during that window used to get fought the exact same way as a layout
// reflow - every frame it put scrollY somewhere other than `target`, this
// snapped it straight back, for as long as the loop kept running (up to the
// full ~6s cap if the visitor kept trying). That read as the page
// "sticking" for a moment and then suddenly "letting go" once the loop
// finally gave up, instead of ever actually following the visitor's own
// scroll. Any one of those events now ends the loop immediately - the
// layout-settling case this loop exists for never fires them, so this only
// ever cuts in for an actual person trying to scroll, handing control back
// on their very first input instead of fighting it first.
const USER_SCROLL_KEYS = new Set(["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", " ", "Spacebar"]);

export const reassertScrollTo = (target) => {
    let cancelled = false;
    let stableFrames = 0;
    let totalFrames = 0;
    const STABLE_FRAMES_TO_STOP = 30; // ~500ms of nothing fighting back
    const MAX_FRAMES = 360; // ~6s hard cap

    const stop = () => {
        if (cancelled) return;
        cancelled = true;
        window.removeEventListener("wheel", onUserScroll);
        window.removeEventListener("touchstart", onUserScroll);
        window.removeEventListener("keydown", onKeyDown);
    };
    const onUserScroll = () => stop();
    const onKeyDown = (e) => { if (USER_SCROLL_KEYS.has(e.key)) stop(); };

    window.addEventListener("wheel", onUserScroll, { passive: true });
    window.addEventListener("touchstart", onUserScroll, { passive: true });
    window.addEventListener("keydown", onKeyDown);

    const tick = () => {
        if (cancelled) return;
        if (window.scrollY !== target) {
            window.scrollTo(0, target);
            stableFrames = 0;
        } else {
            stableFrames += 1;
        }
        totalFrames += 1;
        if (stableFrames < STABLE_FRAMES_TO_STOP && totalFrames < MAX_FRAMES) {
            setTimeout(tick, 16);
        } else {
            stop();
        }
    };
    tick();
    return stop;
};
